/**
 * The source line of a card (v0.1.45): where it came from (Gmail, Etsy message, Etsy order,
 * Sercan, the team), who and when, a link to the original, and the topic tags.
 */

import type { CardSource } from '@twin/contracts';
import { formatClock, formatRelativeClock } from '../lib/format.js';
import { Icon } from './icons.js';

export function SourceLine({ source, now, compact = false }: { source: CardSource; now?: number; compact?: boolean }) {
  return (
    <div className={compact ? 'srcline srcline--compact' : 'srcline'}>
      <span className="stag stag--kind">{source.label}</span>
      {source.from ? <span className="srcline__from">{source.from}</span> : null}
      {source.title ? <span className="srcline__title ellipsis">{source.title}</span> : null}
      {source.at !== null ? (
        <span className="mono srcline__at">
          {now === undefined ? formatClock(source.at) : formatRelativeClock(source.at, now)}
        </span>
      ) : null}
      {source.link ? (
        <a className="srcline__link" href={source.link} target="_blank" rel="noreferrer">
          <Icon name="external-link" size={12} />
          Aç
        </a>
      ) : null}
      {source.tags.map((tag) => (
        <span key={tag} className="stag">
          {tag}
        </span>
      ))}
    </div>
  );
}
